import { DishDispatchContext } from 'components/DishModal';
import { ProvisionTimingProps } from 'models';
import { useContext } from 'react';
import { playSound } from 'sound/Sound';

interface TimingItemProps {
  timingName: string;
  provisionTiming: ProvisionTimingProps;
  timingCode: string;
  dishCode: string;
  orderIdx: number;
  isChild?: boolean;
  groupCode?: string;
  optionCode?: string;
}

const TimingItem = ({
  timingName,
  provisionTiming,
  timingCode,
  dishCode,
  orderIdx,
  isChild = false,
  groupCode,
  optionCode,
}: TimingItemProps) => {
  const dishDispatch = useContext(DishDispatchContext);

  const type = 'radio';
  const checked = provisionTiming.selected_timing === timingCode;

  const handleCheckTiming = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      playSound('sub');

      const timing_info_id = provisionTiming.timing_info_id || '';
      const timing_flg = provisionTiming.timing_flg || '1';
      if (isChild && groupCode && optionCode) {
        dishDispatch({
          type: 'set-child-provision-timing',
          payload: {
            orderIdx,
            groupCode,
            optionCode,
            provisionTiming: {
              selected_timing: timingCode,
              timing_info_id,
              timing_flg,
            },
          },
        });
      } else {
        dishDispatch({
          type: 'set-provision-timing',
          payload: {
            orderIdx,
            provisionTiming: {
              selected_timing: timingCode,
              timing_info_id,
              timing_flg,
            },
          },
        });
      }
    }
  };

  return (
    <div
      className="menu-option"
      style={{
        padding: '10px',
      }}
    >
      <div className={`d-flex align-items-start justify-content-between`}>
        <div className="w-50">
          <label className={`ara-${type}`}>
            <span className={`ara-${type}-text`}>{timingName}</span>
            <input
              id={`option-${dishCode}-${timingCode}-${orderIdx}-${isChild ? 'child' : 'parent'}`}
              type={type}
              name={`option-${dishCode}-${orderIdx}-${isChild ? 'child' : 'parent'}`}
              value={timingCode}
              checked={checked}
              onChange={handleCheckTiming}
            />
            <span className="checkmark"></span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default TimingItem;
